import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {newGuid} from '../../questions/question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';

declare var noUiSlider: any;
declare var wNumb: any;

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    standalone: false
})
export class SliderComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() question: any;
  @Input() readonly = false;
  @Input() sliderWithLabelAside = false;
  @Input() item: any;
  @Input() sliderStep = 1;
  @Input() sliderMin = 0;
  @Input() sliderMax = 0;
  @Input() sliderInit = 0;
  @Input() type = '';
  @Input() called = '';
  @Input() labelText = '';
  @Output() slideUpdate = new EventEmitter<{sliderValue: number}>();

  sliderAmount = 0;
  index = newGuid();
    sliderEl: any;
    sliderInput: any;
  currencyFormat = wNumb({
    prefix: '$ ',
    thousand: ' ',
    decimals: 0
  });
  behaviourSetting = '';

  constructor(public questionService: GlobalQuestionService) {

  }

  ngOnInit(): void {
    
    if (!this.question){
      return;
    }
    
    if (this.question?.min_val === null){
      this.question.min_val = 1000;
      this.question.max_val = 10000;
      this.sliderMin = 1000;
      this.sliderMax = 10000;
    }
    if (!this.sliderMin){
      this.sliderMin = this.question?.min_val;
      
    }
    
    if (!this.sliderMax){
      this.sliderMax = this.question?.max_val;
    }
    
    this.sliderAmount = this.sliderInit;
    if (this.sliderAmount > 0)
      this.slideUpdate.emit({sliderValue: this.sliderAmount});
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if (!this.sliderEl){
      return;
    }

    if (changes?.sliderMin || changes?.sliderMax || changes?.sliderInit || changes?.sliderStep) {
      
      if (changes?.sliderMin?.currentValue) {
        this.sliderMin = changes?.sliderMin?.currentValue;
      }
      else{
        if (changes?.question?.currentValue){
          this.sliderMin = changes?.question?.currentValue?.min_val;
          this.sliderMax = changes?.question?.currentValue?.max_val;
        }
        
      }
      if (changes?.sliderMax?.currentValue) {
        this.sliderMax = changes?.sliderMax?.currentValue;
      }
      if (changes?.sliderInit?.currentValue) {
        
        this.sliderInit = changes?.sliderInit?.currentValue;
        this.sliderAmount = this.sliderInit;
        this.slideUpdate.emit({sliderValue: this.sliderAmount});
      }
      if (changes?.sliderStep?.currentValue) {
        this.sliderStep = changes?.sliderStep?.currentValue;
      }
      if (changes?.sliderWithLabelAside?.currentValue) {
        this.sliderWithLabelAside = changes?.sliderWithLabelAside?.currentValue;
      }
      if (changes?.readonly?.currentValue) {
        this.readonly = changes?.readonly?.currentValue;
      }
      const config = {
        min: Number(changes?.sliderMin?.currentValue ?? this.sliderMin ?? 1000),
        max: Number(changes?.sliderMax?.currentValue ?? this.sliderMax ?? 10000),
        init: Number(changes?.sliderInit?.currentValue ?? this.sliderInit),
        step: Number(changes?.sliderStep?.currentValue ?? this.sliderStep)
      };
      
      this.updateSlider(config);

    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.currencyFormat = wNumb({
        prefix: this.questionService?.currency?.symbol ? this.questionService?.currency?.symbol : 'R ',
        thousand: ' ',
        decimals: 0
      });
      this.initSlider();
    }, 300);
  }

  updateSlider(config: any): void {
    this.sliderInput.value = config.init;
    try{
      this.sliderEl.noUiSlider.destroy();
    }
    catch{}
    

    noUiSlider.create(this.sliderEl, {
      start: config.init,
      step: config.step,
      //snap: true,
      connect: [true, false],
      format: this.currencyFormat,
      behaviour: this.behaviourSetting,
    //   range: {
    //     'min': 0,
    //     '5%': 10,
    //     '10%': 50,
    //     '20%': 100,
    //     '30%': 150,
    //     '40%': 500,
    //     '50%': 800,
    //     'max': 1000
    // },
      range: {
        min: config.min,
        max: config.max
      },
      pips: {
        mode: 'count',
        values: 2,
        density: 100,
        format: this.currencyFormat
      }
    });

    if (!!this.sliderInput) {
      this.sliderEl.noUiSlider.on('update', (values: any, handle: any) => {
        this.sliderInput.value = values[handle];
      });
      this.sliderEl.noUiSlider.on('end', (values, handle, unencoded) => {
        this.sliderInput.value = values[handle];
        this.slideUpdate.emit({sliderValue: Math.round(unencoded[handle])});
      });
    }
  }

  initSlider(): void {
    if (!!matchMedia('(pointer:coarse)').matches) {
      this.behaviourSetting = 'none';
    } else {
      this.behaviourSetting = 'tap';
    }

    this.sliderEl = document.getElementById(`slider${this.index}`);
    this.sliderInput = document.getElementById(`sliderinput${this.index}`);

    if (this.sliderEl) {
      // if (this.sliderMin === this.sliderMax){
      //   this.sliderMin = 0;
      //   this.sliderMax = 10000;
      // }
      
      const config = {
          min: Number(this.sliderMin ?? 0),
          max: Number(this.sliderMax ?? 10000),
          init: Number(this.sliderInit ?? 0),
          step: Number(this.sliderStep)
      };
      this.sliderInput.value = this.sliderInit;
      console.log(config)
      noUiSlider.create(this.sliderEl, {
        start: config.init,
        step: config.step,
        //snap: true,
        connect: [true, false],
        format: this.currencyFormat,
        behaviour: this.behaviourSetting,
      //   range: {
      //     'min': 0,
      //     '5%': 10,
      //     '10%': 50,
      //     '20%': 100,
      //     '30%': 150,
      //     '40%': 500,
      //     '50%': 800,
      //     'max': 1000
      // },
        range: {
          min: config.min,
          max: config.max
        },
        pips: {
          mode: 'count',
          values: 2,
          density: 100,
          format: this.currencyFormat
        }
      });

      if (!!this.sliderInput) {
        this.sliderEl.noUiSlider.on('update', (values: any, handle: any) => {
          this.sliderInput.value = values[handle];
        });
        this.sliderEl.noUiSlider.on('end', (values, handle, unencoded) => {
          this.sliderInput.value = values[handle];
          this.slideUpdate.emit({sliderValue: Math.round(unencoded[handle])});
        });
      }

    }
  }

  onInputChange(event: any): void {
    let value = event?.target?.value;
    if (value && this.sliderEl) {
      value = this.currencyFormat.from(value);
      /*value = +value;*/
      if (isNaN(value)) {
        return;
      }

      if (this.sliderMax && (value > this.sliderMax)) {
        value = this.sliderMax;
      } else if (!this.sliderMax && (value > 10000)) {
        value = 10000;
      }
      if (this.sliderMin && (value < this.sliderMin)) {
        value = this.sliderMin;
        
      } else if (!this.sliderMin && (value < 0)) {
        value = 0;
      }
      this.sliderEl.noUiSlider.set(value);
      this.slideUpdate.emit({sliderValue: Math.round(value)});
    }
  }


}
